module.exports = __webpack_public_path__ + "img/login-trans.95450a20.png";